var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusBasicIcon = function SvgPlusBasicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7 .292c.483 0 .874.391.874.875v4.958h4.959a.875.875 0 0 1 0 1.75H7.874v4.958a.875.875 0 0 1-1.75 0V7.875H1.166a.875.875 0 1 1 0-1.75h4.958V1.167c0-.484.392-.875.875-.875Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlusBasicIcon;